import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import classNames from "./LayoutPopover.module.css";
import * as Popover from "@radix-ui/react-popover";
import { useCallback, useState } from "react";
import { useMeeting } from "../../../hooks/meeting";
import { initialMeetingState } from "../../../types";
import Button from "../../common/Button";
import { StatelessToggle } from "../../common/Toggle";

export default function LayoutPopover() {
  const [isOpen, setIsOpen] = useState(false);

  const [meeting, setMeeting] = useMeeting();
  const resetPanelLayout = useCallback(() => {
    setMeeting((prevState) => ({
      ...prevState,
      layout: initialMeetingState.layout,
    }));
  }, [setMeeting]);

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>
        <Button color="gray" backgroundColor="black" borderColor="dark-gray">
          Panels {!isOpen ? <IoChevronDown /> : <IoChevronUp />}
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className={classNames.LayoutPopoverContent}
          align="start"
          sideOffset={8}
        >
          <div>Panel Display</div>
          <div
            className={classNames.LayoutPopoverToggle}
            onClick={() =>
              setMeeting((prevState) => ({
                ...prevState,
                layout: {
                  ...prevState.layout,
                  panels: {
                    ...prevState.layout.panels,
                    participants: !prevState.layout.panels.captions
                      ? true
                      : !prevState.layout.panels.participants,
                  },
                },
              }))
            }
          >
            <StatelessToggle enabled={meeting.layout.panels.participants} />
            Participants
          </div>
          <div
            className={classNames.LayoutPopoverToggle}
            onClick={() =>
              setMeeting((prevState) => ({
                ...prevState,
                layout: {
                  ...prevState.layout,
                  panels: {
                    ...prevState.layout.panels,
                    captions: !prevState.layout.panels.participants
                      ? true
                      : !prevState.layout.panels.captions,
                  },
                },
              }))
            }
          >
            <StatelessToggle enabled={meeting.layout.panels.captions} />
            Captions
          </div>
          <div
            className={classNames.ResetPanelLayout}
            onClick={resetPanelLayout}
          >
            Reset Panel Layout
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
